import { Partner, PartnerUpdate } from "@happy-legal/graphql-types";
import { graphQlClient } from "../clients";
import {
  MUTATION_ADD_PARTNER,
  MUTATION_DELETE_PARTNER,
  MUTATION_UPDATE_PARTNER,
} from "../gql/mutations";
import { QUERY_GET_ALL_PARTNERS } from "../gql/queries";
import { partnerInitState } from "../providers/PartnerProvider";
import { handleCatchReducer } from "./handleCatchReducer";

export const GET_ALL_PARTNERS = "GET_ALL_PARTNERS";
type TGET_ALL_PARTNERS = {
  type: "GET_ALL_PARTNERS";
  filter?: PartnerUpdate;
};

export const ADD_PARTNER = "ADD_PARTNER";
type TADD_PARTNER = {
  type: "ADD_PARTNER";
  payload: PartnerUpdate;
};

export const UPDATE_PARTNER = "UPDATE_PARTNER";
type TUPDATE_PARTNER = {
  type: "UPDATE_PARTNER";
  payload: PartnerUpdate;
};

export const DELETE_PARTNER = "DELETE_PARTNER";
type TDELETE_PARTNER = {
  type: "DELETE_PARTNER";
  id: string;
};

export type TPartnerAction =
  | TGET_ALL_PARTNERS
  | TADD_PARTNER
  | TUPDATE_PARTNER
  | TDELETE_PARTNER;

export const partnerReducer = async (
  state: Partner[],
  action: TPartnerAction
) => {
  try {
    switch (action.type) {
      case GET_ALL_PARTNERS: {
        const newState = await graphQlClient(QUERY_GET_ALL_PARTNERS, {
          filter: action?.filter,
        });

        return newState;
      }

      case ADD_PARTNER: {
        const newState = await graphQlClient(MUTATION_ADD_PARTNER, {
          input: action.payload,
        }).then((res) => {
          // Add new discount to state
          const newDiscounts = [...state, res];
          return newDiscounts;
        });

        return newState;
      }

      case UPDATE_PARTNER: {
        const { id, ...input } = action.payload;

        const newState = await graphQlClient(MUTATION_UPDATE_PARTNER, {
          id,
          input: input,
        }).then((res) => {
          const isUpdatingPartner = state.some(
            (partner) => partner.id === res.id
          );

          // Update discount via id
          if (isUpdatingPartner) {
            const updatedPartners = state.map((partner) =>
              partner.id === res.id ? res : partner
            );
            return updatedPartners;
          }
          // Add new discount to state
          else {
            const newDiscounts = [...state, res];
            return newDiscounts;
          }
        });

        return newState;
      }

      case DELETE_PARTNER: {
        await graphQlClient(MUTATION_DELETE_PARTNER, {
          id: action.id,
        });

        const newState = state?.filter((partner) => partner.id !== action.id);

        return newState;
      }

      default: {
        return state;
      }
    }
  } catch (err) {
    handleCatchReducer("partner", err);
    return partnerInitState;
  }
};
